import _styled2 from "styled-components";
import _styled from "styled-components";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
var CharacterCount = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var style = _ref.style,
    className = _ref.className,
    count = _ref.count,
    maxLength = _ref.maxLength;
  var hasOverflowed = count > maxLength;
  return /*#__PURE__*/React.createElement(_StyledSpan, {
    ref: ref,
    className: className,
    $_css: [_objectSpread(_objectSpread({}, theme.typography.labelSmall), {}, {
      color: theme.colors.charcoal700,
      pointerEvents: 'none'
    }), style]
  }, /*#__PURE__*/React.createElement(_StyledSpan2, {
    $_css2: [_objectSpread({}, hasOverflowed && {
      color: theme.colors.red600
    })]
  }, count), "/".concat(maxLength));
});
CharacterCount.displayName = 'CharacterCount';
CharacterCount.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Current number of characters in the input */
  count: PropTypes.number.isRequired,
  /** Max number of character allowed in the input */
  maxLength: PropTypes.number.isRequired
};
export default CharacterCount;
var _StyledSpan = _styled("span").withConfig({
  displayName: "CharacterCount___StyledSpan",
  componentId: "sc-yh2j3h-0"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledSpan2 = _styled("span").withConfig({
  displayName: "CharacterCount___StyledSpan2",
  componentId: "sc-yh2j3h-1"
})(["", ""], function (p) {
  return p.$_css2;
});
//# sourceMappingURL=CharacterCount.js.map